import wow from "wow.js";

const $ = require('jquery');

new wow().init();

/**
 * Animate the "Jetzt testen" button in all places
 */
window.setInterval(e => {

    let animationClasses = 'animate__animated animate__rubberBand';

    $('.navbar .btn-test')
        .addClass(animationClasses)
        .on('animationend', e => $(e.target).removeClass(animationClasses));

}, 10000);

const header = document.getElementsByTagName('header')[0];
const headerScene = document.querySelector('header .image-container > *');
const navbarLogo = document.querySelector('.navbar-brand > img');

let parallaxHandler = e => {

    document.body.style.backgroundPosition = 'left ' + (900 + (window.scrollY/3)) + 'px';

    if (headerScene) {
        headerScene.style.transform = 'translateY(' + (window.scrollY/2) + 'px)';
    }

    navbarLogo.style.maxHeight = Math.max(50, 77 - (window.scrollY/30)) + 'px';

};

window.onscroll = e => {
    window.requestAnimationFrame(parallaxHandler);
};

window.requestAnimationFrame(parallaxHandler);


if (headerScene.classList.contains('parallax')) {

    const Parallax = require('parallax-js');

    var parallaxInstance = new Parallax(scene, {
        relativeInput: true,
        selector: '.layer',
        frictionX: 0.1,
        frictionY: 0.1,
        scalarX: $(window).width() < 1000 ? 25 : 5,
        scalarY: $(window).width() < 1000 ? 1 : 1,
        pointerEvents: true,
    });

}


